import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';

import EmptyFaculty from './EmptyFaculty';

class EmptyFacultyModal extends Component {
  state = {
    modalOpen: true,
  };
  handleBrowseModalClose = () => {
    this.setState(() => ({ modalOpen: false }));
  };
  render() {
    return (
      <Modal open={this.state.modalOpen} size="mini">
        <Modal.Content>
          <EmptyFaculty {...this.props} onBrowseModalClose={this.handleBrowseModalClose} />
        </Modal.Content>
      </Modal>
    );
  }
}
export default EmptyFacultyModal;
